// extracted by mini-css-extract-plugin
module.exports = {"dialogContent":"YoutubePopup__dialogContent___1UkHa","videoIcon":"YoutubePopup__videoIcon___2ztfl"};